import { cloneObject } from '@simonbackx/simple-encoding';
import { AuditLogReplacement } from '../AuditLogReplacement.js';
import { StamhoofdFilterDecoder } from './FilteredRequest.js';
import { isEmptyFilter } from './StamhoofdFilter.js';
export class PropertyFilter {
    constructor(enabledWhen, requiredWhen) {
        /**
         * Enabled when...
         * null = always enabled
         */
        this.enabledWhen = null;
        /**
         * If enabled, whether it is required
         * null = always skippable
         * empty filter = always required
         */
        this.requiredWhen = null;
        this.enabledWhen = enabledWhen;
        this.requiredWhen = requiredWhen;
    }
    static createDefault() {
        return new PropertyFilter(null, {});
    }
    isEnabled(object) {
        if (this.enabledWhen === null) {
            return true;
        }
        return object.doesMatchFilter(this.enabledWhen);
    }
    get isAlwaysEnabledAndRequired() {
        return this.enabledWhen === null && isEmptyFilter(this.requiredWhen) && this.requiredWhen !== null;
    }
    isRequired(object) {
        if (this.requiredWhen === null) {
            return false;
        }
        return object.doesMatchFilter(this.requiredWhen);
    }
    encode(context) {
        return {
            enabledWhen: StamhoofdFilterDecoder.encode(this.enabledWhen, context),
            requiredWhen: StamhoofdFilterDecoder.encode(this.requiredWhen, context),
        };
    }
    static decode(data) {
        if (data.context.version < 251) {
            console.error('PropertyFilter: legacy filter detected - this is not implemented yet. Possible data loss.');
            return PropertyFilter.createDefault();
        }
        return new PropertyFilter(data.field('enabledWhen').nullable(StamhoofdFilterDecoder), data.field('requiredWhen').nullable(StamhoofdFilterDecoder));
    }
    clone() {
        return new PropertyFilter(cloneObject(this.enabledWhen), cloneObject(this.requiredWhen));
    }
    getDiffValue() {
        if (this.isAlwaysEnabledAndRequired) {
            return AuditLogReplacement.key('alwaysEnabledAndRequired');
        }
        if (this.enabledWhen === null && this.requiredWhen === null) {
            return AuditLogReplacement.key('alwaysEnabledAndOptional');
        }
        if (this.enabledWhen !== null && this.requiredWhen === null) {
            return AuditLogReplacement.key('sometimesEnabledAndOptional');
        }
        if (this.enabledWhen === null && this.requiredWhen !== null) {
            return AuditLogReplacement.key('alwaysEnabledAndSometimesRequired');
        }
        if (this.enabledWhen !== null && isEmptyFilter(this.requiredWhen)) {
            return AuditLogReplacement.key('sometimesEnabledAndRequired');
        }
        return AuditLogReplacement.key('sometimesEnabledAndSometimesRequired');
    }
}
//# sourceMappingURL=PropertyFilter.js.map